import { AttractionsList } from '@/components/attractions';
import { PageContainer, type CrudListHeaderAction } from '@startupquickstart/frontend';
import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { GenerateAttractionAction, GenerateAttractionIcon } from './actions';

/**
 * Attractions list page with Generate Attraction action
 * Legacy: /Users/Thomas/projects/destinationtours/app/client/src/views/content/attractions/Attractions.jsx:19-94
 */
export function AttractionsPage() {
  const { listId } = useParams<{ listId?: string }>();
  const [generateModalOpen, setGenerateModalOpen] = useState(false);

  // Define custom header actions for the list view
  const headerActions: CrudListHeaderAction[] = useMemo(
    () => [
      {
        key: 'generate',
        label: 'Generate Attraction',
        icon: GenerateAttractionIcon,
        variant: 'secondary',
        onClick: () => setGenerateModalOpen(true),
      },
    ],
    [],
  );

  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Attractions', current: true },
  ];

  return (
    <PageContainer>
      <AttractionsList headerActions={headerActions} breadcrumbs={breadcrumbs} listId={listId} />
      <GenerateAttractionAction
        open={generateModalOpen}
        onOpenChange={setGenerateModalOpen}
      />
    </PageContainer>
  );
}
